
import api from "./API";

export const InvoiceService = {
  createInvoice: async (params) => {
    return await api.post(`/create-invoice`, { ...params })
  },

}